import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'


const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "flex items-center gap-2 text-xs text-gray-400" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "ml-1",
  src: _imports_0,
  alt: "wa-icon"
}, null, -1)
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = { class: "flex items-center gap-2 text-xs text-gray-400" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "ml-1",
  src: _imports_0,
  alt: "wa-icon"
}, null, -1)
const _hoisted_7 = {
  class: "font-normal",
  "data-testid": "pickup-dashboard-row-total-shipment"
}
const _hoisted_8 = { class: "font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TableSummary = _resolveComponent("TableSummary")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_TableSummary, {
      columns: _ctx.columns,
      tableData: _ctx.detailSummary,
      sortKey: _ctx.sortKey,
      sortOrder: _ctx.sortOrder,
      enableSort: true,
      pagination: _ctx.pagination,
      startIndex: _ctx.startIndex,
      isLoading: _ctx.isLoading,
      onSort: _ctx.handleSort,
      onSetPage: _ctx.onPageChange,
      onSelectAll: _ctx.handleSelectAll,
      onSelectRow: _ctx.onSelectRow
    }, {
      "cell-senderName": _withCtx(({ item }) => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", {
            title: item.senderName,
            class: "font-medium text-gray-900 two-line",
            style: {"width":"200px"}
          }, _toDisplayString(item.senderName), 9, ["title"]),
          _createVNode("a", {
            target: "_blank",
            href: `https://wa.me/${item.senderPhone}`
          }, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(_ctx.formatPhoneNumber(item.senderPhone)), 1),
              _hoisted_3
            ])
          ], 8, ["href"])
        ])
      ]),
      "cell-courierName": _withCtx(({ item }) => [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", {
            title: `${item.courierId} - ${item.courierName}`,
            class: "font-medium text-gray-900 two-line",
            style: {"width":"200px"}
          }, _toDisplayString(`${item.courierId} - ${item.courierName}`), 9, ["title"]),
          _createVNode("a", {
            target: "_blank",
            href: `https://wa.me/${item.courierPhone}`
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode("span", null, _toDisplayString(_ctx.formatPhoneNumber(item.courierPhone)), 1),
              _hoisted_6
            ])
          ], 8, ["href"])
        ])
      ]),
      "cell-totalShipment": _withCtx(({ item }) => [
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.fmtQty(item.totalShipment)) + " (" + _toDisplayString(_ctx.fmtQty(item.totalQuantity)) + ")", 1)
      ]),
      "cell-statusAt": _withCtx(({ item }) => [
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDate(item.statusAt)), 1)
      ]),
      "cell-proofs": _withCtx(({ item }) => [
        _createVNode("span", {
          class: ["font-normal", 
          `${
            item.proofs.length
              ? 'underline text-red-lp-100 cursor-pointer'
              : 'text-gray-lp-300 cursor-auto'
          }`
        ],
          onClick: ($event: any) => (_ctx.onHandleModal(item))
        }, _toDisplayString(item.proofs.length ? _ctx.$t("pickupDashboard.viewProof") : "-"), 11, ["onClick"])
      ]),
      "cell-actionBooking": _withCtx(({ item }) => [
        _createVNode("button", {
          onClick: ($event: any) => (_ctx.onBooking(item)),
          class: "p-2 hover:bg-gray-100 rounded-lg transition-colors",
          disabled: !item.isAbleToBooking
        }, [
          _createVNode(_component_Icons, {
            name: "calender-plus",
            class: 
            `${
              !item.isAbleToBooking ? 'text-gray-lp-1300' : 'text-gray-lp-300'
            }`
          
          }, null, 8, ["class"])
        ], 8, ["onClick", "disabled"])
      ]),
      _: 1
    }, 8, ["columns", "tableData", "sortKey", "sortOrder", "pagination", "startIndex", "isLoading", "onSort", "onSetPage", "onSelectAll", "onSelectRow"]),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.showImagePreview,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showImagePreview = $event)),
      data: _ctx.images,
      image: _ctx.image,
      isTerm: false,
      onClose: _ctx.closeImagePreview
    }, null, 8, ["modelValue", "data", "image", "onClose"])
  ], 64))
}